import { render, staticRenderFns } from "./VirementB.vue?vue&type=template&id=293a773f&"
import script from "./VirementB.vue?vue&type=script&lang=js&"
export * from "./VirementB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VirementB.vue"
export default component.exports